// extracted by mini-css-extract-plugin
module.exports = {"colorList":"nhTCqX"};